import { Box, SystemIcon, Typography } from '@wishket/design-system';
import { PropsWithChildren } from 'react';

import { NameWithLink } from '../Footer.types';

import {
  FOOTER_OTHER_SERVICE_LINKS,
  FOOTER_USAGE_LINKS,
  FOOTER_WISHKET_INFO_LINKS,
} from '../Footer.constants';

import { Link } from '@/shared/Components';

interface LinkSetProps extends PropsWithChildren {
  title?: string;
}

const LinkWithArrow = ({ name, link, isNewWindow }: NameWithLink) => {
  return (
    <Link
      href={link}
      className="flex items-center gap-0.5 hover:underline"
      target={isNewWindow ? '_blank' : '_self'}
    >
      <Typography variant="body1" className="flex font-medium text-w-gray-600">
        {name}
      </Typography>
      <SystemIcon name="medium_arrow_right" className="text-w-gray-600" />
    </Link>
  );
};

const CompanyServiceLink = ({ name, link }: NameWithLink) => {
  return (
    <Link href={link} target="_blank">
      <Typography variant="body2" className="text-w-gray-600 hover:underline">
        {name}
      </Typography>
    </Link>
  );
};

const LinkMenu = ({ title, children }: LinkSetProps) => {
  return (
    <Box className="flex w-[185px] flex-col gap-3">
      {title && (
        <Typography variant="body1" className="font-medium text-w-gray-600">
          {title}
        </Typography>
      )}
      <Box className="flex flex-col gap-2">{children}</Box>
    </Box>
  );
};

export const LinkSet = () => {
  return (
    <Box
      className="hidden grid-in-link desktop:flex"
      data-testid="footer-link-set"
    >
      <LinkMenu title="요즘IT">
        {FOOTER_WISHKET_INFO_LINKS.map((info) => (
          <CompanyServiceLink
            key={info.name}
            name={info.name}
            link={info.link}
          />
        ))}
      </LinkMenu>
      <LinkMenu title="기타 문의">
        {FOOTER_USAGE_LINKS.map((usage) => (
          <CompanyServiceLink
            key={usage.name}
            name={usage.name}
            link={usage.link}
          />
        ))}
      </LinkMenu>
      <Box className="flex flex-col gap-3">
        {FOOTER_OTHER_SERVICE_LINKS.map((service) => (
          <LinkWithArrow
            key={service.name}
            name={service.name}
            link={service.link}
            isNewWindow={service.isNewWindow}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LinkSet;
